import { Route, Switch } from "react-router-dom";

import BrandComponent from "../../components/page/product/brand/BrandComponent";
import CooperateProductComponent from "../../components/page/product/CooperateProductComponent";
import CooperateRegisterComponent from "../../components/page/product/CooperateRegisterComponent";
import ProductComponent from "../../components/page/product/ProductComponent";
import ProductRegisterComponent from "../../components/page/product/ProductRegisterComponent";

const ProductPage = () => {
  return (
    <Switch>
      <Route exact path="/product/view" component={ProductComponent} />
      <Route
        path="/product/register/:id"
        component={ProductRegisterComponent}
      />
      <Route path="/product/register" component={ProductRegisterComponent} />
      <Route
        path="/product/cooperate_view"
        component={CooperateProductComponent}
      />
      <Route
        path="/product/cooperate_register/:id/:influencerId"
        component={CooperateRegisterComponent}
      />
      <Route
        path="/product/cooperate_register"
        component={CooperateRegisterComponent}
      />
      <Route path="/product/brand/view" component={BrandComponent} />
    </Switch>
  );
};

export default ProductPage;
